import { ViewerStore } from './ViewerStore';

export default ViewerStore;
